import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Grid, TablePagination } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { fetchMotivosBajaTurno } from '../../../actions/turnos/motivosBajaTurno';
import { agendaLimpiar, confirmarBajaTurnos, fetchTurnosPorParametrizacion } from '../../../actions/turnos/agenda';
import { efectorHorariosLimpiar, fetchEfectorHorarios } from '../../../actions/turnos/efectorHorarios';
import { useForm } from "../../../hooks/useForm";
import { AlertFinalizadoStepper } from '../../stepper/AlertFinalizadoStepper';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { ParametrosBaja } from './ParametrosBaja';
import { ListaTurnosBaja } from './ListaBajaTurnos';
import { TableToolbarBajaMasiva } from './TableToolbarBajaMasiva';
import { MOTIVOS_BAJA_TURNOS } from "../../../utils/constants";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 5,
        flexGrow: 1,
        marginTop: 5,
    },
    input: {
        padding: 10,
    },
    grid: {
        backgroundColor: theme.palette.background.paper,
    },
    formControl: {
        marginTop: 5,
        minWidth: 120,
        marginLeft: 20,
        margin: theme.spacing(1),
    }, 
    button: {
        marginLeft: 25,
    }
}));

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const formatFecha = fecha => {
    return new Date(fecha).toLocaleString(
        "es",
        optionsfecha
    );
};

const translateDia = dia => {
    switch (dia) {
        case 'LU':
          return 'LUNES'
        case 'MA':
          return 'MARTES'
        case 'MI':
          return 'MIERCOLES'
        case 'JU':
          return 'JUEVES'
        case 'VI':
          return 'VIERNES'
        case 'SA':
          return 'SABADO'
        case 'DO':
          return 'DOMINGO'
        default:
          return 'ERROR'
      }
};

const stateInitial = {
    fechaDesde: new Date(),
    fechaHasta: new Date(),
    idParametrizacion: '',
    idMotivoBajaTurno: '',
    tomadoLibre: 0,
};  

export const BajaMasiva = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { items, cargada } = useSelector((state) => state.agenda);
    const { items: itemsParametrizaciones } = useSelector((state) => state.efectorHorarios);
    const { items: motivosBajaItems, cargada: motivosBajaCargados } = useSelector((state) => state.motivosBajaTurno);
    const [idCentroMedico, setIdCentroMedico] = useState(null);
    const [idProfesional, setIdProfesional] = useState(null);
    const [idEspecialidad, setIdEspecialidad] = useState(null);
    const [listaItems, setListaItems] = useState([]);
    const [openBaja, setOpenBaja] = useState(false);
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const [ formValues, handleInputChange, , setearValor, , , , , setearVariosValores ] = useForm(stateInitial);
    const { fechaDesde, fechaHasta, idParametrizacion, idMotivoBajaTurno, tomadoLibre } = formValues;

    const handleInputChangeCascada = ({ target }) => {
        switch (target.name) {
            case 'idCentroMedico':
                setIdCentroMedico(target.value);
                setIdProfesional(null);
                setIdEspecialidad(null);
                break;
            case 'idProfesional':
                if(target.value === ''){
                    setIdProfesional(null);
                }
                else{
                    setIdEspecialidad(null);
                    setIdProfesional(target.value);
                }
                break;
            case 'idEspecialidad':
                setIdEspecialidad(target.value);
                // target.value&& dispatch( fetchEfectorHorarios(idCentroMedico, idProfesional, target.value) );
                break;
            default:
                break;
        }
        dispatch( efectorHorariosLimpiar() );
        dispatch( agendaLimpiar() );
    }

    useEffect(() => {
        dispatch( agendaLimpiar() );
    }, [dispatch]);

    useEffect(() => {
        setListaItems(items);
    }, [items]);

    useEffect(() => {
        idEspecialidad&& dispatch( fetchEfectorHorarios(idCentroMedico, idProfesional, idEspecialidad) );
    }, [dispatch, idCentroMedico, idProfesional, idEspecialidad]);

    useEffect(() => {
        if (!motivosBajaCargados)
            dispatch( fetchMotivosBajaTurno() );
    }, [dispatch, motivosBajaCargados]);

    const handleSelectAllClick = (event) => {        
        if (event.target.checked) {
          const newSelecteds = listaItems.filter( (obj) => !obj.confirmado && moment(obj.fecha).isSameOrAfter(moment(), 'day') ).map( (obj) => obj.idAgenda );
          setSelected(newSelecteds);
          return;
        }
        setSelected([]);
    };

    const handleClick = (idAgenda) => {
        const selectedIndex = selected.indexOf(idAgenda);
        let newSelected = [];
    
        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, idAgenda);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1)
          );
        }
        setSelected(newSelected);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSubmitSearch = e => {
        dispatch( fetchTurnosPorParametrizacion(idParametrizacion, fechaDesde.toISOString(), fechaHasta.toISOString(), idCentroMedico, idProfesional, idEspecialidad) );
        handleInputChange({target:{name: 'tomadoLibre', value: 0}})
        setSelected([]);
    }

    const handleFilterSearch=(value)=>{
        if(value===0)
            setListaItems(items);
        if(value===1)
            setListaItems(items.filter(s => s.idAfiliado));
        else if(value===2)
            setListaItems(items.filter(s => !s.idAfiliado));
        setSelected([]);
    }

    const handleCloseAlert = () => {
        resetValues();
        setOpenBaja(false);
    }

    const resetValues = () => {
        setSelected([]);
        handleInputChange({target:{name: 'idMotivoBajaTurno', value: null}})
    }

    const handleSendBajaTurno = (turno) => {
        setSelected([turno.idAgenda]);
        setOpenBaja(true);
    }

    const handleSendBajaTurnos = () => {
        dispatch( confirmarBajaTurnos(selected, idMotivoBajaTurno) );
        setOpenBaja(false);
        resetValues();
    }

    return ( 
        <>
            <ValidatorForm onSubmit={handleSubmitSearch}>
                <div className={classes.root}>
                    <Grid container className={classes.root} justify="center" spacing={1}>  
                        <Grid item xs={8} style={{backgroundColor: 'white'}}>
                            <ParametrosBaja
                                classes={classes}
                                fechaDesde={fechaDesde}
                                fechaHasta={fechaHasta}
                                setearValor={setearValor}
                                formatFecha={formatFecha}
                                translateDia={translateDia}
                                idProfesional={idProfesional}
                                idCentroMedico={idCentroMedico}
                                idEspecialidad={idEspecialidad}
                                idParametrizacion={idParametrizacion}
                                setIdEspecialidad={setIdEspecialidad}
                                handleInputChange={handleInputChange}
                                setearVariosValores={setearVariosValores}
                                itemsParametrizaciones={itemsParametrizaciones}
                                handleInputChangeCascada={handleInputChangeCascada}
                            />
                        </Grid>
                        <Grid item xs={9}>
                            <ListaTurnosBaja
                                page={page}
                                cargada={cargada}
                                items={listaItems}
                                selected={selected}
                                isSelected={isSelected}
                                tomadoLibre={tomadoLibre}
                                formatFecha={formatFecha}
                                rowsPerPage={rowsPerPage}
                                handleClick={handleClick}
                                handleInputChange={handleInputChange}
                                handleSendBajaTurno={handleSendBajaTurno}
                                handleSelectAllClick={handleSelectAllClick}
                                handleFilterSearch={handleFilterSearch}
                            />
                        </Grid>
                        <Grid item xs={9}>
                            {cargada&& listaItems.length > 0&&
                                <>
                                    <TablePagination
                                        style={{backgroundColor: 'white'}}
                                        rowsPerPageOptions={[5, 10, 25]}
                                        component="div"
                                        count={listaItems.length}
                                        rowsPerPage={rowsPerPage}
                                        labelRowsPerPage='Registros por página'
                                        page={page}
                                        onChangePage={handleChangePage}
                                        onChangeRowsPerPage={handleChangeRowsPerPage}
                                    />
                                </>
                            }
                        </Grid>
                        <Grid item xs={9}>
                            <Grid item container>
                                <Grid item xs={3}></Grid>
                                <Grid item xs={6}>
                                    {cargada&& listaItems.length > 0&&
                                        <TableToolbarBajaMasiva 
                                            numSelected={selected.length} 
                                            handleSubmit={() => setOpenBaja(true)}
                                        />
                                    }
                                </Grid>
                                <Grid item xs={3}></Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </ValidatorForm>
            {openBaja&&
                <AlertFinalizadoStepper
                    open={openBaja}
                    pregunta={'Baja de Turno'}
                    dialogText={'Quiere proceder con la Baja del Turno?'}
                    buttonCancel={"Cancelar"}
                    buttonSubmit={"Continuar"}
                    showComboDialog={true}
                    itemsCombo={motivosBajaItems.filter(s => s.idMbt !== MOTIVOS_BAJA_TURNOS.CANCELADO_POR_AFILIADO)}
                    labelCombo={'Motivo'}
                    idCombo={'idMotivoBajaTurno'}
                    manejadorInputChange={handleInputChange}
                    valor={idMotivoBajaTurno}
                    handleClose={handleCloseAlert}
                    handleSend={handleSendBajaTurnos}
                />
            }
        </>
     );
}